import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

import Copyright from './Copyright';
import FooterCountry from './FooterCountry';
import FooterLang from './FooterLang';
import FooterLogo from './FooterLogo';
import FooterNav from './FooterNav';
import License from './License';
import Partners from './Partners';
import SocialLinks from './SocialLinks';

const FooterContainer = styled.footer`
    width: 100%;
    padding: 32px 0;
    background: ${promoColors.gray5};

    ${promoMedia.tablet744} {
        padding: 48px 0;
    }

    ${promoMedia.desktop1440} {
        padding: 64px 0;
    }
`;
const FooterInner = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 20px;
    padding-right: 20px;

    ${promoMedia.tablet744} {
        max-width: 620px;
        padding-left: 62px;
        padding-right: 62px;
    }

    ${promoMedia.desktop1440} {
        max-width: 1280px;
        padding-left: 80px;
        padding-right: 80px;
    }
`;
const FooterRow = styled.div`
    margin-bottom: 32px;

    ${promoMedia.tablet744} {
        display: ${(props) => (props.horizontalTablet ? 'flex' : null)};
        align-items: ${(props) => (props.horizontalTablet ? 'center' : null)};
    }
`;

const Footer = ({ data = {}, ...props }) => {
    const renderFooter = () => {
        if (props.renderOptions?.isGlobalAccount) {
            return (
                <>
                    <FooterNav links={data.links} lang={props.lang} country={props.country} isLanding={props.isLanding} />
                    <FooterNav links={data.legalLinks} lang={props.lang} country={props.country} isLanding={props.isLanding} />
                    <FooterRow>
                        <FooterCountry countryCode={data.countryCode} countryName={data.countryName} country={props.country} />
                    </FooterRow>
                    <FooterLogo lang={props.lang} country={props.country} />
                    <License licence={data?.licence} />
                    <Partners />
                </>
            );
        } else if (props.renderOptions?.isLibre) {
            return (
                <>
                    <FooterLogo lang={props.lang} country={props.country} />
                    <SocialLinks links={data.socialLinks} />
                    <Copyright copyright={data.copyright} />
                    <License licence={data?.licence} />
                    <Partners />
                </>
            );
        } else {
            const isShowSocialLinks = !props.renderOptions?.isBusinessConnect && !props.renderOptions?.isHR;
            const hideFooterCountryLang = props.renderOptions?.hideFooterCountryLang;

            return (
                <>
                    <FooterNav links={data.links} lang={props.lang} country={props.country} isLanding={props.isLanding} />
                    <FooterNav links={data.legalLinks} lang={props.lang} country={props.country} isLanding={props.isLanding} />
                    {!hideFooterCountryLang && (
                        <FooterRow horizontalTablet>
                            <FooterCountry countryCode={data.countryCode} countryName={data.countryName} country={props.country} />
                            <FooterLang isLanding={props.isLanding} isRequest={props.isRequest} />
                        </FooterRow>
                    )}
                    <FooterLogo lang={props.lang} country={props.country} />
                    {isShowSocialLinks && <SocialLinks links={data.socialLinks} />}
                    <Copyright copyright={data.copyright} />
                    {!props.renderOptions?.isHR && (
                        <>
                            <License licence={data?.licence} />
                            <Partners />
                        </>
                    )}
                </>
            );
        }
    };

    return (
        <FooterContainer>
            <FooterInner>{renderFooter()}</FooterInner>
        </FooterContainer>
    );
};

Footer.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    isLanding: PropTypes.bool.isRequired,
    data: PropTypes.shape({
        links: PropTypes.array.isRequired,
        legalLinks: PropTypes.array,
        socialLinks: PropTypes.arrayOf(
            PropTypes.shape({
                isBlank: PropTypes.bool,
                name: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            }),
        ),
        copyright: PropTypes.string.isRequired,
        licence: PropTypes.string,
        countryCode: PropTypes.string.isRequired,
        countryName: PropTypes.string.isRequired,
    }).isRequired,
};
export default Footer;
